/**
 * Normalize the response shape returned by legacy file-query endpoints.
 * Depending on grid mode and gateway version, the collection may be a bare
 * array or live under items/rows, optionally wrapped by data.
 *
 * @param {Array|Object|null|undefined} response file-query response
 * @returns {Array} normalized file records
 */
export const normalizeFileResponseItems = (response) => {
  if (Array.isArray(response)) {
    return response;
  }
  if (!response || typeof response !== 'object') {
    return [];
  }
  if (Array.isArray(response.items)) {
    return response.items;
  }
  if (Array.isArray(response.rows)) {
    return response.rows;
  }
  if (response.data && response.data !== response) {
    return normalizeFileResponseItems(response.data);
  }
  return [];
};

/**
 * Legacy business endpoints are inconsistent: some return the business object
 * directly while others wrap it in `data`. Preserve outer status fields while
 * exposing the inner fields to existing form/detail consumers.
 *
 * @param {Object|null|undefined} response endpoint response
 * @returns {Object|null|undefined} normalized business response
 */
export const normalizeObjectResponseData = (response) => {
  if (!response || typeof response !== 'object' || Array.isArray(response)) {
    return response;
  }
  if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
    return {
      ...response,
      ...response.data,
    };
  }
  return response;
};
